module.exports = __webpack_public_path__ + "static/img/link.8f8b6be4.png";